import createTokenUpdate from '../UserActions/Streams/createTokenUpdate';
import createWatchedEvent from './Streams/createWatchedEvent';
import subscribeToWatchedEvent from './Subscribers/subscribeToWatchedEvent';
import subscribeToUserActionsWatchedResponse from './Subscribers/subscribeToUserActionsWatchedResponse';

const connectUserActionsWatched = middleware => {
    const {
        asset,
        config,
        userActions,
    } = middleware.state.stores;

    return [
        subscribeToWatchedEvent(
            createWatchedEvent(
                createTokenUpdate(config.update$),
                userActions.update$,
                asset.update$,
                middleware.player
            ),
            middleware.apiServices.userActionsWatched.request$,
        ),
        subscribeToUserActionsWatchedResponse(
            middleware.apiServices.userActionsWatched.response$,
        ),
    ];
};

export default connectUserActionsWatched;
